import React from "react";
import "./About.scss";
import { EditOutlined } from "@ant-design/icons";
import { TUserSectionProp } from "@utils/Interfaces";
import { Empty, Skeleton } from "antd";

const About: React.FC<TUserSectionProp> = ({
  setIsEditProfileVisible,
  setActiveTab,
  userProfile,
  loading,
}) => {
  return (
    <div className="card card-profile about">
      <div
        className="edit-action"
        onClick={() => {
          setIsEditProfileVisible(true);
          setActiveTab("2");
        }}
      >
        <EditOutlined />
      </div>
      <div className="card-title">About</div>
      <div className="about-description">
        {!loading ? (
          <Skeleton active />
        ) : userProfile.about == null || userProfile.about == "" ? (
          <Empty />
        ) : (
          userProfile.about
        )}
      </div>
    </div>
  );
};

export default About;
